export default __webpack_public_path__ + "static/media/lm_hs.4bbeed2c.png";